<template>
  <div>
    <el-radio-group @change="()=>changeFunction()" v-model="radiogroupValue" :ref="radiogroupRef" :style="`
      ${radiogroupData.questioncolumn ? 'flex-direction:column; display:flex; margin-top: 10px; margin-bottom: 10px;' :''}
      ${radiogroupData.indent > 0 ? 'margin-left: ' +  radiogroupData.indent + 'px;' :''}
    `">
      <!-- <span style="font-size: 32px;">DEF</span> -->
      <div v-for="(suboption, index) in radiogroupData.optionSetOptionList" :key="index">
        <template v-if="suboption.optionHoverLabel">
          <el-tooltip :content="suboption.optionHoverLabel" placement="right-start" effect="light">
            <el-radio :label="suboption.optionLabel" :value="suboption.optionLabel" :disabled="locked" :key="index">
              {{ suboption.optionLabel }}
              <i class="el-icon-info"></i>
            </el-radio>
          </el-tooltip>
        </template>
        <template v-else>
          <el-radio :label="suboption.optionLabel" :value="suboption.optionLabel" :disabled="locked" :key="index">{{ suboption.optionLabel }}</el-radio>
        </template>
        <!-- <span style="font-size: 32px;">{{suboption.optionLabel}}</span> -->
        <template v-if="suboption.optionSubOptionSetList">
          <div v-for="(suboptionset, index2) in suboption.optionSubOptionSetList" :key="index2">
            <!-- <span style="font-size: 32px;">{{radiogroupValue}}</span>
            <span style="font-size: 32px;">{{radiogroupValue === suboption.optionLabel}}</span> -->
            <template v-if="radiogroupValue === suboption.optionLabel">
              <stu-radio-group :changeFunction="changeFunction" v-if="suboptionset.optionSetType === 'radio'" :formData="formData" :parentId="`${parentId}_${radiogroupData.optionSetId}_${suboption.optionId}`" :radiogroupData="suboptionset" :radiogroupRef="`${radiogroupRef}_suboptionset${index}`" :locked="locked"></stu-radio-group>
              <stu-checkbox-group :changeFunction="changeFunction" v-else-if="suboptionset.optionSetType === 'checkbox'" :formData="formData" :parentId="`${parentId}_${radiogroupData.optionSetId}_${suboption.optionId}`" :checkboxgroupData="suboptionset" :checkboxgroupRef="`${radiogroupRef}_suboptionset${index}`" :locked="locked"></stu-checkbox-group>
            </template>
          </div>
        </template>
        <template v-if="suboption.optionSubQuestionList">
          <div v-for="(subquestion, index4) in suboption.optionSubQuestionList" :key="index4">
            <!-- <span style="display: inline; line-height: 32px; font-size: 32px;">{{ `${parentId}_${radiogroupData.optionSetId}_${suboption.optionId}` }}</span> -->
            <stu-question :changeFunction="changeFunction" :style="index4 === 0 ? 'margin-top: 15px;' : ''" v-if="radiogroupValue === suboption.optionLabel" :formData="formData" :parentId="`${parentId}_${radiogroupData.optionSetId}_${suboption.optionId}`" :questionData="subquestion" :questionRef="`${radiogroupRef}_subquestion${index4}`" :locked="locked"></stu-question>
          </div>
        </template>
      </div>
    </el-radio-group>
    <div v-for="(subquestion, index5) in radiogroupData.optionSetSubQuestionList" :key="index5">
      <!-- <span style="display: inline; line-height: 32px; font-size: 32px;">{{radiogroupValue}}</span> -->
      <template v-if="radiogroupValue && questionSiblingBehavior(subquestion)">
        <stu-question :changeFunction="changeFunction" :formData="formData" :parentId="`${parentId}_${radiogroupData.optionSetId}`" :questionData="subquestion" :questionRef="`${radiogroupRef}_subquestion${index5}`" :locked="locked"></stu-question>
      </template>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  // .slide-fade-enter-active {
  //   transition: all .3s ease;
  // }
  // .slide-fade-leave-active {
  //   transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  // }
  // .slide-fade-enter, .expand-fade-leave-active {
  //   margin-left: 20px;
  //   opacity: 0;
  // }
</style>
<script>
export default {
  name: "stu-radio-group",
  data() {
    return {
      radiogroupValue: "",
      btnloading: false,
    }
  },
  props: {
    radiogroupData: {
      type: Object
    },
    radiogroupRef: {
      type: String
    },
    formData: {
      type: Object
    },
    changeFunction: {
      type: Function
    },
    parentId: {
      type: String
    },
    locked: {
      type: Boolean
    }
  },
  methods: {
  },
  watch: {
    radiogroupValue() {
      this.formData[`${this.parentId}_${this.radiogroupData.optionSetId}`] = this.radiogroupValue
      for (var option of this.radiogroupData.optionSetOptionList) {
        const optionId = option.optionId
        const checked = this.radiogroupValue === option.optionLabel
        this.formData[`${this.parentId}_${this.radiogroupData.optionSetId}_${optionId}`] = checked
      }
    },
    questionSiblingBehavior(question) {
      if (question.questionSiblingSpecialBehavior === 'revealOnly' && question.questionSiblingList && question.questionSiblingList.length > 0) {
        let visible = true
        // console.log(this.formData)
        for (var sibling of question.questionSiblingList) {
          const questionSiblingOptionId = sibling.questionSiblingOptionId
          const questionSiblingOptionValue = sibling.questionSiblingOptionValue
          const siblingKey = `${this.parentId}_${this.checkboxgroupData.optionSetId}_${questionSiblingOptionId}`
          // console.log(`${siblingKey}`, this.formData[siblingKey])
          if (this.formData[siblingKey] !== questionSiblingOptionValue) {
            visible = false
            break
          }
        }
        return visible
      }
      return true
    }
  },
  computed: {
    // suboptions() {
    //   // const suboptions = []
    //   if (this.radiogroupData) {
    //     // for (var i in this.radiogroupData.optionSetOptionList) {
    //     //   const optionSetOption = this.radiogroupData.optionSetOptionList[i]
    //     //   const optionSubOptionSetList = optionSetOption.optionSubOptionSetList
    //     //   if (optionSubOptionSetList.length > 0) {
    //     //     suboptions.push(optionSetOption)
    //     //   }
    //     // }
    //     // return suboptions
    //     return this.radiogroupData.optionSetOptionList ? this.radiogroupData.optionSetOptionList : []
    //   }
    //   return []
    // }
  },
  mounted() {
    // console.log(`${this.parentId}_${this.radiogroupData.optionSetId}`)
    // console.log(this.formData[`${this.parentId}_${this.radiogroupData.optionSetId}`])
    // console.log("mounted", `${this.parentId}_${this.radiogroupData.optionSetId}`)
    this.radiogroupValue = this.formData[`${this.parentId}_${this.radiogroupData.optionSetId}`]
  },
  beforeDestroy() {
  },
};
</script>


// WEBPACK FOOTER //
// src/views/msma/components/StuRadioGroup.vue